/**
 * エリアガイド詳細の初期化
 */
export function initAreasDetail($) {
  if ($('body.single-areas').length === 0) return;

  // スライド（現在はコメントアウト）
  /*
  $('.c-slide').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    dots: false,
  });
  */
}
